import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import MenuWithLabel from 'src/components/Common/Menu';
import { LogTypeEnum } from '@Types/log';

import DataTrack from '../../../components/DataTrack';
import { MenuOption } from '../../../types';

const LOG_TYPES = [
  LogTypeEnum.DETECTION,
  LogTypeEnum.QUARANTINE,
  LogTypeEnum.URLTRACKING,
  LogTypeEnum.INLINETRACKING,
  LogTypeEnum.APIINTEGRATION,
  LogTypeEnum.ADUIT,
];

const LogTypeSelection = ({
  type,
  setLogType,
  inlineFlag,
}: {
  type: LogTypeEnum;
  setLogType: (type: LogTypeEnum) => void;
  inlineFlag: boolean;
}) => {
  const { t } = useTranslation();
  const logTypesMenu: MenuOption[] = useMemo(() => {
    return LOG_TYPES.filter(
      (item) => !(item === LogTypeEnum.INLINETRACKING && !inlineFlag)
    ).map((type) => {
      const logTypeI18n = t(`log.type.${type}`);
      return { key: type, value: logTypeI18n };
    });
  }, [inlineFlag, t]);

  return (
    <DataTrack type="Log.LogType.Selected" metadata={{ logType: type }}>
      <MenuWithLabel
        onClick={(e: any) => {
          const type = e.target.getAttribute('value');
          setLogType(type);
        }}
        menuItems={logTypesMenu}
        selectedKey={type}
        label={t('log.labels.logType')}
        minWidth={288}
      />
    </DataTrack>
  );
};
export default React.memo(LogTypeSelection);
